// extracted by mini-css-extract-plugin
export default {"bubbling":"bubbling_HBOQs","bubblingCompact":"bubblingCompact_NnEeM","bubblingBtn":"bubblingBtn_bpRlC","topBubbles":"topBubbles_obHUb","bottomBubbles":"bottomBubbles_Wdx8W"};